/*
 * Copyright (c) 2024 Paul Ostrowski. All rights reserved.
 *
 * This software is the proprietary information of Paul Ostrowski.
 * Unauthorized copying, modification, or distribution of this code, via any medium, is strictly prohibited.
 * This code is proprietary and confidential.
 *
 * For licensing inquiries, contact Paul Ostrowski at postrowski@gmail.com.
*/

import { Open5eV2Document } from './Open5eV2';

// Represents anything carrying Open5e source/document info, in either:
//   - v1 shape: flat document__* fields
//   - v2 shape: a nested `document` object
// At runtime an object has exactly one of these — the helpers below resolve it.
interface Open5eDocument {
    document__slug?:        string;
    document__title?:       string;
    document__license_url?: string;
    document__url?:         string;
    document?:              Open5eV2Document;
}

export function getDocKey(item: Open5eDocument): string {
    return item.document?.key || item.document__slug || '';
}

export function getDocTitle(item: Open5eDocument): string {
    return item.document?.display_name || item.document__title || '';
}

export default Open5eDocument;
